import type { IconNode } from '../types';

/**
 * @name bucket
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNiA3YzAtMi44IDIuMi01IDUtNWgyYzIuOCAwIDUgMi4yIDUgNSIgLz4KICA8cGF0aCBkPSJNNSAxMWgxNCIgLz4KICA8cGF0aCBkPSJtMTggMTEtLjggOWMtLjEgMS4xLTEuMSAyLTIuMiAySDljLTEuMSAwLTIuMS0uOS0yLjItMkw2IDExIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/bucket
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const bucket: IconNode = [
  ['path', { d: 'M6 7c0-2.8 2.2-5 5-5h2c2.8 0 5 2.2 5 5', key: 'drbtoh' }],
  ['path', { d: 'M5 11h14', key: '17iare' }],
  ['path', { d: 'm18 11-.8 9c-.1 1.1-1.1 2-2.2 2H9c-1.1 0-2.1-.9-2.2-2L6 11', key: '4picm6' }],
];

export default bucket;
